import { ChangeDetectorRef, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DistrictData } from 'src/app/models/DistrictData';
import { SearchStudentByKeywordsRequest } from 'src/app/models/Requests/SearchStudentByKeywordsRequest.model';
import { StudentDetails } from 'src/app/models/Search/studentdetails';
import { Campus } from 'src/app/models/campus.model';
import { LocationService } from 'src/app/services/location.service';
import { ViewStudentDetailsComponent } from '../dialogs/view-student-details/view-student-details.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccessLevel, Login } from 'src/app/models/login.model';
import { StudentService } from 'src/app/services/student.service';
import { UserRequest } from 'src/app/models/Requests/UserRequest.model';
import { CampusRequest } from 'src/app/models/Requests/CampusRequest.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-search-by-campus',
  templateUrl: './search-by-campus.component.html',
  styleUrls: ['./search-by-campus.component.scss']
})
export class SearchByCampusComponent {

  searchRequest = new SearchStudentByKeywordsRequest("", "", "", "", 0, 0, 0, 0, 0, 0, 0);
  displayedColumns: string[] = ['firstName', 'lastName', 'dateofBirth', 'location', 'memberid', 'rosterStatus', 'actions']
  students: StudentDetails[] = [];
  schoolDistricts: DistrictData[] = [];
  campuses: Campus[] = [];
  loggedInUser = new Login("", "", "", "", "", "", 0, false, false, false, "");
  dataSource: MatTableDataSource<StudentDetails> = new MatTableDataSource(this.students);
  dataSourceWithPageSize = new MatTableDataSource(this.students);
  enumAccessLevel = AccessLevel;
  @Input() selectedSchoolYear: string;
  @Input() isSearchKeyword: boolean = false;
  pageEvent: PageEvent = {
    pageIndex: 0,
    pageSize: 10,
    length: 100
  };
  manualPage: number;
  pageIndex: number = 0;
  showMsg: boolean = false;
  pageNumbers: number[] = [];
  noOfPages: number = 0;
  selectedPageNumber : number = 1;
  currenttotalPages:number = 0;
  goTo:number;
  @ViewChild('srchStdByCmpsPaginator', { static: false }) srchStdByCmpsPaginator: MatPaginator;

  isLoadingStudents: boolean = false;

  constructor(private locationService: LocationService, private matDialog: MatDialog, private authService: AuthenticationService, private studentService: StudentService, private cdref: ChangeDetectorRef) {

  }

  ngOnInit() {


    this.authService.setLogin.subscribe(loginData => {
      this.loggedInUser = loginData;
      this.getDistricts();


    });
  }
  ngOnChanges(changes: SimpleChanges) {

    if (!changes['isSearchKeyword']?.currentValue) {
      this.reset();
    }
  }
  reset() {
    this.showMsg = false;
    this.searchRequest = new SearchStudentByKeywordsRequest("", "", "", "", 0, 0, 0, 0, 0, 0, 0);
    this.students = [];
    this.dataSource = new MatTableDataSource(this.students);
    this.campuses = []
    this.getDistricts();
  }

  getDistricts() {
    this.schoolDistricts = [];

    let userRequest = new UserRequest(this.loggedInUser.userId, this.loggedInUser.accessId, false);
    if(userRequest.userID.trim().length > 0 && userRequest.accessID != 0)
    this.locationService.getDistrictsByUserRole(userRequest).subscribe({
      next: (result: any) => {

        result.forEach((item: { policyno: number; client: string; }) => {
          let  data = {
            policyNo: item.policyno,
            client: item.client,
            state: ""
          } as DistrictData;

          this.schoolDistricts.push(data);
        });
        if ((this.loggedInUser.accessLevel == this.enumAccessLevel.CAMPUSUSER&&this.schoolDistricts.length==1) || this.loggedInUser.accessLevel == this.enumAccessLevel.DISTRICTUSER || this.loggedInUser.accessLevel == this.enumAccessLevel.VIEWONLYUSER) {
          this.searchRequest.schoolDistrict = this.schoolDistricts[0].policyNo;
          this.getCampus();
        }
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }

  getCampus() {

    this.campuses = [];

    let campusRequest = new CampusRequest(this.loggedInUser.userId, this.searchRequest.schoolDistrict, this.loggedInUser.accessId.toString());

    this.locationService.getCampus(campusRequest).subscribe({
      next: (result: any) => {

        result.forEach((item: { campusID: number; campusName: string; }) => {
          let data = {
            campusID: item.campusID,
            campusName: item.campusName
          } as Campus;


          this.campuses.push(data);
        });
        if (this.loggedInUser.accessLevel == this.enumAccessLevel.CAMPUSUSER && this.campuses.length==1) {
          this.searchRequest.campusID = this.campuses[0].campusID;
        }
        if ((this.loggedInUser.isCampus&&this.campuses.length==1) || this.campuses.length==1  || this.loggedInUser.accessLevel == 1 || this.loggedInUser.accessLevel == 4) {
          this.Search();
        }
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }

  Search() {
    if (this.searchRequest.schoolDistrict == 0 || this.searchRequest.campusID == 0) {
      return;
    }

    this.searchRequest.accessID = this.loggedInUser.accessId;
    this.searchRequest.accessLevel = this.loggedInUser.accessLevel;
    this.searchRequest.schoolYear = Number(this.selectedSchoolYear);
    this.searchRequest.campusName = this.campuses.find(x=>x.campusID==this.searchRequest.campusID)?.campusName;
    this.searchRequest.pageNumber = 1;
    this.searchRequest.pageSize = 10;

    this.isLoadingStudents = true;

    this.studentService.searchStudentsByCampus(this.searchRequest).subscribe((result) => {
      this.students = result;
      this.dataSource = new MatTableDataSource(this.students);
      //this.dataSource.paginator = this.srchStdByCmpsPaginator;
      if(this.srchStdByCmpsPaginator ){
        this.dataSource.paginator = this.srchStdByCmpsPaginator;
        }

      //this.dataSourceWithPageSize = new MatTableDataSource(this.students);
      this.cdref.detectChanges();
      this.setPageNumbers();
      this.updateGoto();
      if (this.students.length == 0) {
        this.showMsg = true;
      }else{
        this.showMsg = false;
      }

      this.isLoadingStudents = false;
    });
  }

  OpenStudentDetailsPopup(element: StudentDetails) {
    if (element != null) {
      this.matDialog.open(ViewStudentDetailsComponent, {
        data: element
      });
    }
  }

  GetNumbers() {
    this.pageNumbers = [];
    const value = Math.ceil(this.students.length / 10);
    this.noOfPages = value;
    if (value > 4) {
      this.pageNumbers.push(1);
      this.pageNumbers.push(2);
      this.pageNumbers.push(value - 1);
      this.pageNumbers.push(value);
    } else {
      for (let i = 0; i < value; i++) {
        this.pageNumbers.push(i + 1);
      }
    }
  }

  UpdateManualPage(index: number): void {
    this.manualPage = index;
    this.pageEvent.pageIndex = index;
    this.pageIndex = index;
    this.srchStdByCmpsPaginator.pageIndex = index;
    this.srchStdByCmpsPaginator.page.next({
      pageIndex: index,
      pageSize: 10,
      length: this.students.length
    });
  }
  printExcel() {
    if (this.students.length > 0) {
      const workbook = XLSX.utils.book_new();
      const campusName = this.campuses.find(x => x.campusID == this.searchRequest.campusID)?.campusName;
      const data = this.getStudentData(campusName!);
      const worksheet = XLSX.utils.json_to_sheet(data);

      const filename = this.loggedInUser.userId + '_Student_List' + '.xlsx';
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Student_List');
      // XLSX.writeFile(workbook, filename);
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const a: HTMLAnchorElement = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
        // FileSaver.saveAs(file);
    }
  }
  getStudentData(campusName: string): any[] {
    let students: any[] = [];
    this.students.forEach(s => {
      let student = {
        'First Name': s.firstName,
        'Last Name': s.lastName,
        'Date Of Birth': formatDate(new Date(s.dob), 'MM/dd/yyyy', 'en-IN'),
        'Location': campusName.trim(),
        'Member ID': s.ssn,
        // 'IDNum': '*********',
        'Eff Date': formatDate(new Date(s.coverageStart), 'MM/dd/yyyy', 'en-IN'),
        'Exp Date': formatDate(new Date(s.coverageEnd), 'MM/dd/yyyy', 'en-IN'),
        'Rate': s.rate,
        'Plan Description': s.activity,
        'Roster Entry': s.cC_TransactionID!=null&&s.cC_TransactionID!=""?(s.cC_TransactionID.includes('ROSTER') ? "TRUE" : ""):""
      }
      students.push(student);
    });
    return students;
  }

  updateGoToPage() {

    this.srchStdByCmpsPaginator.pageIndex = this.goTo - 1;
  }

  goToChange() {
    this.srchStdByCmpsPaginator.pageIndex = this.goTo - 1;
    const event: PageEvent = {
      length: this.srchStdByCmpsPaginator.length,
      pageIndex: this.srchStdByCmpsPaginator.pageIndex,
      pageSize: this.srchStdByCmpsPaginator.pageSize
    };
    this.srchStdByCmpsPaginator.page.next(event);
  }

  updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.srchStdByCmpsPaginator?.length/ this.srchStdByCmpsPaginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
  }
  onPaginateChange(event:any){
    this.selectedPageNumber = event.pageIndex +1;
    this.goTo = this.selectedPageNumber;
    this.setPageNumbers();
  }

  setPageNumbers(){
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.srchStdByCmpsPaginator?.length/ this.srchStdByCmpsPaginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
    this.currenttotalPages = this.pageNumbers.length;
  }
}
